var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",staticStyle:{"margin-bottom":"0"}},[(_vm.url)?_c('div',{staticClass:"box-iframe"},[_c('iframe',{attrs:{"id":"myIframe","src":_vm.url,"frameborder":"0"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }